module.exports = __webpack_public_path__ + "media/assets/images/flags/bt-14fb8bb75f7111925c3d56495d9f69cd.svg";